/* unplugin-vue-components disabled */import script from "./StagePropsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StagePropsCard.vue?vue&type=script&setup=true&lang=js"

import "./StagePropsCard.vue?vue&type=style&index=0&id=20731c5a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20731c5a"]])

export default __exports__